import { useApplications } from 'api/applications/queries/useApplications'
import { CodeDropList } from './CodeDropList'

export const ApplicationCodeDropList = ({ onChange }: { onChange: (value?: string) => void }) => {
  return <CodeDropList onChange={onChange} label="Properties" useFunction={useApplications} />
}
